import type { ReactNode } from "react";
import { Code, Settings2 } from "lucide-react";
import { StepInfoRow } from "../StepInfoRow";
import { StepCodeBlock } from "../StepCodeBlock";
import { getString, getNumber } from "./helpers";
import type { SummaryTranslator } from "./types";

export function getCodeSummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const language = getString(config.language) || "javascript";
  const code = getString(config.code);
  const timeout = getNumber(config.timeout);

  items.push(
    <StepInfoRow
      key="lang"
      icon={<Code className="size-3.5" />}
      label={t("summaries.code.label_language")}
      value={
        <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium text-slate-700 dark:bg-slate-900/30 dark:text-slate-300">
          {language}
        </span>
      }
    />
  );

  if (code) {
    items.push(
      <StepCodeBlock
        key="code"
        icon={<Code className="size-3.5" />}
        label={t("summaries.code.label_code")}
        code={code}
        title={t("summaries.code.code_title", { language })}
        language={language === "javascript" || language === "typescript" ? language : "javascript"}
      />
    );
  }

  if (timeout) {
    items.push(
      <StepInfoRow key="timeout" icon={<Settings2 className="size-3.5" />} label={t("summaries.code.label_timeout")} value={t("summaries.code.timeout_seconds", { seconds: timeout })} />
    );
  }

  return items;
}
